
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('mask',{attrs:{"id":"a","x":"3","y":"1.52","width":"19.55","height":"22.16","maskUnits":"userSpaceOnUse"}},[_c('g',{attrs:{"data-name":"mask-2"}},[_c('path',{attrs:{"data-name":"path-1","fill-rule":"evenodd","fill":"#fff","d":"M3 1.52h19.55v22.16H3V1.52z"}})])])]),_c('g',{attrs:{"data-name":"Social icons schwarz"}},[_c('g',{attrs:{"data-name":"Group-8"}},[_c('g',{attrs:{"mask":"url(#a)","data-name":"Group-3"}},[_c('path',{attrs:{"data-name":"Fill-1","d":"M22.55 6.72a5.23 5.23 0 01-5.25-5.2h-3.94v15.09a3.21 3.21 0 11-3.21-3.18 3.73 3.73 0 011 .14v-4a8.42 8.42 0 00-1-.07 7.08 7.08 0 107.15 7.08v-8a8.31 8.31 0 005.25 1.85z","fill":"#ff0b53","fill-rule":"evenodd"}})]),_c('path',{attrs:{"data-name":"Fill-4","d":"M21.25 5.41A5.23 5.23 0 0116 .22h-3.95V15.3a3.21 3.21 0 11-3.2-3.17 3.79 3.79 0 011 .14v-4a6.77 6.77 0 00-1-.07A7.07 7.07 0 1016 15.3v-8a8.39 8.39 0 005.26 1.85z","fill":"#00f0e9","fill-rule":"evenodd"}}),_c('path',{attrs:{"data-name":"Fill-6","d":"M21.25 6.66a5.24 5.24 0 01-3.09-2 5.27 5.27 0 01-2-3.12h-2.91v15.23a3.17 3.17 0 01-5.9 1.65 3.21 3.21 0 011.62-6 3.66 3.66 0 011 .14v-3a7.17 7.17 0 00-5.42 11.68A7 7 0 009 22.81a7.11 7.11 0 007.08-7.15V7.58a8.13 8.13 0 005.2 1.87z","fill-rule":"evenodd"}})])])])
          )
        }
      }
    